import { useState, useEffect, useRef } from 'react';
import '../../../entrydoor.css';
import { formatToDecimal, formatToFractional } from '../../../controls/conversions';

// Calculates the default frame height based on door height
const calcHeight = (doorHeightValue) => {
  if (doorHeightValue === "6'8\"" || doorHeightValue === "6'8") return '82 3/8"';
  if (doorHeightValue === "7'"   || doorHeightValue === "7")   return '87 3/8"';
  if (doorHeightValue === "8'"   || doorHeightValue === "8")   return '98 3/8"';
  return '';
};

const FrameHeight = ({ value = { value: '', label: '' }, onChange, disabled = false, doorHeight }) => {
  const [selected, setSelected] = useState(value?.value || '');
  const [error,    setError]    = useState('');
  const skipValueSync = useRef(false);

  // Auto-calculate when doorHeight changes
  useEffect(() => {
    if (doorHeight?.value) {
      const calc = calcHeight(doorHeight.value);
      if (calc) {
        skipValueSync.current = true;
        setSelected(calc);
        onChange({ value: calc, label: calc });
      }
    }
  }, [doorHeight?.value]);

  // Sync from parent only for external changes (e.g. load from DB)
  useEffect(() => {
    if (skipValueSync.current) { skipValueSync.current = false; return; }
    setSelected(value?.value || '');
  }, [value?.value]);

  const validate = (v) => {
    const num = parseFloat(formatToDecimal(v));
    if (v && !isNaN(num) && (num < 34 || num > 196)) {
      setError('Frame Height must be between 34" and 196"');
    } else {
      setError('');
    }
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setSelected(v);
    validate(v);
  };

  const handleFocus = (e) => {
    const dec = formatToDecimal(e.target.value);
    setSelected(dec === '0' || dec === 0 ? '' : dec);
  };

  const handleBlur = (e) => {
    const formatted = formatToFractional(e.target.value);
    setSelected(formatted);
    onChange({ value: formatted, label: formatted });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdFrameHeight">Frame Height</label>
      <input
        id="SdFrameHeight"
        value={selected}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        placeholder='e.g. 82 3/8"'
      />
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default FrameHeight;
